import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from '../baseApi';

export interface ApprovalRuleMember {
  ID: number;
  RULE_ID: number;
  APPROVER_NAME: string;
  APPROVER_ID: number | null;
  PLANT: string;
  IS_ACTIVE: boolean;
  createdAt: string;
  updatedAt: string;
  rule?: {
    WORK_CENTER: string;
    MATERIAL_CATEGORY: string;
  };
}

export interface AddApproverRequest {
  ruleId: number;
  approverId: number;
  approverName: string;
  plant: string;
}

export interface Manager {
  ID: number;
  ROLEID: number;
  USERID: number;
  IS_ACTIVE: boolean;
  user: {
    ID: number;
    USERNAME: string;
    USERID: string;
  };
}

export const approverApi = createApi({
  reducerPath: 'approverApi',
  baseQuery: createBaseQuery('approver/'),
  tagTypes: ['Approvers'],
  endpoints: (builder) => ({
    getAllApprovers: builder.query<
  { approvers: any[]; pagination: any },
  { page: number; limit: number; q?: string }
>({
  query: ({ page, limit, q }) =>
    `getAllApprovers?page=${page}&limit=${limit}&q=${q || ""}`,
  transformResponse: (response: { approvers: any[]; pagination: any }) => response,
  providesTags: ["Approvers"],
}),
    addApprover: builder.mutation<ApprovalRuleMember, AddApproverRequest>({
      query: (body) => ({
        url: 'addApprover',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Approvers'],
    }),
    deleteApprover: builder.mutation<{ message: string }, number>({
      query: (id) => ({
        url: `removeApprover/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Approvers'],
    }),
    getManagersByPlant: builder.query<Manager[], string>({
      query: (plantName) => `getManagersByPlant/${plantName}`,
      transformResponse: (response: { message: string; managers: Manager[] }) => response.managers,
    }),
  }),
});

export const { useGetAllApproversQuery, useAddApproverMutation, useDeleteApproverMutation, useGetManagersByPlantQuery } = approverApi;
